import React from 'react';
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3">
      <div className="container text-center">
        <span style={{color: 'white'}}>© 2023 TravelBae. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
